import React, { useState } from "react";
import { FaCalendarAlt, FaEnvelope, FaHandshake, FaHome, FaLock, FaNewspaper, FaUser } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import {
	Bars,
	ExternalLink,
	MenuButton,
	Nav,
	NavBtn,
	NavBtnLink,
	NavLink,
	NavMenu,
} from "./NavbarElements";

const NavBar = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { pathname } = useLocation();
	const closeMenu = () => setIsOpen(false);
	const isHomeActive = pathname === "/" || pathname === "/home";

	return (
		<Nav aria-label="Main navigation">
			<NavBtn>
				<NavBtnLink to="/home" onClick={closeMenu} aria-label="Ken & Bryn home">
					<img src="/logo-transparent.png" alt="" aria-hidden="true" />
				</NavBtnLink>
			</NavBtn>
			<MenuButton
				type="button"
				aria-label="Toggle navigation menu"
				aria-expanded={isOpen}
				aria-controls="main-navigation-menu"
				onClick={() => setIsOpen((open) => !open)}
			>
				<Bars aria-hidden="true" />
			</MenuButton>
			<NavMenu id="main-navigation-menu" $isOpen={isOpen}>
				<NavLink to="/home" onClick={closeMenu} className={isHomeActive ? "active" : undefined}>
					<FaHome aria-hidden="true" />
					<span>Home</span>
				</NavLink>
				<NavLink to="/about" onClick={closeMenu}>
					<FaUser aria-hidden="true" />
					<span>About</span>
				</NavLink>
				<NavLink to="/events" onClick={closeMenu}>
					<FaCalendarAlt aria-hidden="true" />
					<span>Events</span>
				</NavLink>
				<NavLink to="/lessons" onClick={closeMenu}>
					<FaCalendarAlt aria-hidden="true" />
					<span>Lessons</span>
				</NavLink>
				<NavLink to="/presskit" onClick={closeMenu}>
					<FaNewspaper aria-hidden="true" />
					<span>Press Kit</span>
				</NavLink>
				<NavLink to="/media-kit" onClick={closeMenu}>
					<FaHandshake aria-hidden="true" />
					<span>Media Kit</span>
				</NavLink>
				<NavLink to="/contact" onClick={closeMenu}>
					<FaEnvelope aria-hidden="true" />
					<span>Contact</span>
				</NavLink>
				<ExternalLink
					href="https://members.kenandbryn.dance"
					target="_blank"
					rel="noopener noreferrer"
					onClick={closeMenu}
				>
					<FaLock aria-hidden="true" />
					<span>Members</span>
				</ExternalLink>
			</NavMenu>
		</Nav>
	);
};

export default NavBar;
